module.exports = __webpack_public_path__ + "img/m_bg6.e3c58364.png";